import { initializeFirebase, type FirebaseConfig } from '@paneon/auth';

/**
 * Firebase configuration for Paneon App
 * Project: paneon-app
 */
const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'paneon-app.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'paneon-app',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'paneon-app.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeFirebase(firebaseConfig);

export { firebaseConfig };
